export default "__VITE_ASSET__BsyDzo_w__"